module.exports = __webpack_public_path__ + "img/banner.aa2be5e4.png";